const ImageCollectionCategory = {
	GENERAL: "General",
	CHARTS: "Charts",
	SHIPPING_LANES: "Shipping Lanes"
};
export default ImageCollectionCategory;
